export default __webpack_public_path__ + "static/media/carouselImage2_1.56eb6a63.png";